module.exports = __webpack_public_path__ + "static/media/mira_launch_2.a288ff85.jpeg";